module.exports = {
    theme: {
        extend: {
            colors: {
                primary: 'var(--color-primary)',
                'primary-inverse': 'var(--color-primary-inverse)',
                secondary: 'var(--color-secondary)',
                'secondary-inverse': 'var(--color-secondary-inverse)',
                tertiary: 'var(--color-tertiary)',
                'tertiary-inverse': 'var(--color-tertiary-inverse)',
                brandOrange: '#EF7D14',
                brandGreen: '#00A26C',
            },
        },
        fontFamily: {
            roboto: ['Roboto', 'sans-serif'],
            lexend: ['Lexend', 'sans-serif'],
        },
    },

    plugins: [
        require('@tailwindcss/aspect-ratio'),
        require('@tailwindcss/typography'),
        require('@tailwindcss/forms'),
    ],

    content: [
        __dirname + '/galaxy/modules/*/resources/**/*.{vue,js,scss,php}',
        __dirname + '/app/Modules/*/resources/**/*.{vue,js,scss,php}',
        __dirname + '/resources/**/*.{vue,js,scss,php}',
    ],
};
